import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { StyledAccountMenu, StyledDropDown, StyledSideItem, StyledUserEmail } from '@bit/knotchinc.web-react-components.side-nav';
import AccountSwitchModal from './AccountSwitchModal.jsx';
import { AccountIcon } from './styled.js';

class AccountDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAccountSwitchModalOpen: false,
    };
  }

  render() {
    const { accountName, userEmail, isAccountAdmin, hasSwitchableAccounts, hideSettings } = this.props;
    const { isAccountSwitchModalOpen } = this.state;

    return (
      <StyledAccountMenu>
        <AccountSwitchModal isOpen={isAccountSwitchModalOpen} close={() => this.setState({ isAccountSwitchModalOpen: false })} />
        <StyledDropDown>
          <StyledSideItem as={Link} to="/blueprint/logout">
            Log Out
          </StyledSideItem>
          {!hideSettings && <StyledSideItem as={Link} to="/blueprint/settings">
            Settings
          </StyledSideItem>}
          {hasSwitchableAccounts &&
          <StyledSideItem onClick={() => this.setState({ isAccountSwitchModalOpen: true })}>
            Switch Accounts
          </StyledSideItem>}
          {isAccountAdmin &&
          <StyledSideItem as={Link} to="/blueprint/users">
            Admin
          </StyledSideItem>}
        </StyledDropDown>
        <StyledSideItem >
          <StyledUserEmail>{userEmail}</StyledUserEmail>
          <div>
            <AccountIcon />
            <span>{accountName}</span>
          </div>
        </StyledSideItem>
      </StyledAccountMenu>
    );
  }
}

function mapStateToProps({ Account: { isAccountAdmin, data: { name, email, available_accounts } }, routing }) {
  return {
    routing,
    accountName: name,
    userEmail: email,
    hasSwitchableAccounts: available_accounts && available_accounts.length > 0,
    isAccountAdmin,
  };
}

export default connect(mapStateToProps)(AccountDropDown);
